import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AIandMLpage.css";

import aiandml from "../../assests/aiandml-img.svg"
import heroImg from "../../assests/Background-img.svg";

// Components
import ARVRSecondpage from "../Ar-vrServicespage/ARVRSecondpage";

import ContactFormModal from "../header/ContactFormModal";
import CoreServices from "../coreServices/coreServices";
import BusinessValue from "../BusinessValue/BusinessValue";
import WhyIOTSection from "../WhyIOTSection/WhyIOTSection";
import ArBusiness from "../Ar-vrServicespage/ArBusiness";
import SoftwareCoreServices from "../SoftwareCoreServices/SoftwareCoreServices";
import AICoreServices from "../AI-CoreServices/AICoreServices";
import { useNavigate } from "react-router-dom";
// Define service type  
type Service = {
  id: string;
  title: string;
  icon: string;
  items: string[];
  hasRoute: boolean;
  routePath?: string;
};

const AIandMLpage: React.FC = () => {
  const navigate = useNavigate();
  const [activeService] = useState("ar");
    const [showContactForm, setShowContactForm] = useState(false);

  const handleServiceClick = (service: Service) => {
    if (service.hasRoute && service.routePath) {
      window.location.href = service.routePath;
    }
  };

  return (
    <div className="aiandml-services-page">
      {showContactForm && <ContactFormModal onClose={() => setShowContactForm(false)} />}
      {/* Hero Section */}
<section
  className="hero-section-aiandml d-flex align-items-center justify-content-center"
  style={{
    backgroundImage: `url(${heroImg})`,
    backgroundSize: "cover",
  }}
>
  <div className="container-aiandml text-center">
    <h1 className="hero-title-aiandml">AI & ML Automation</h1>
    <p className="hero-subtitle-aiandml">
      Harness AI and automation to drive efficiency, innovation, and business transformation.
    </p>
    <button
      className="btn  hero-button-aiandml"
      onClick={() => navigate("/Contact-Us")}
    >
      Get in Touch
    </button>
  </div>
</section>

      {/* Other Sections */}
      <AICoreServices/>
      <BusinessValue/>
      <WhyIOTSection/>
      <ArBusiness/>
    </div>
  );
};

export default AIandMLpage;
